module.exports = __webpack_public_path__ + "img/xcb-subject-mirror7-logo.17639cfb.png";